import { makeAutoObservable } from 'mobx';
import PopupType from '../interfaces/PopupType';

export default class PopupStore {
    id: number | null = null;
    longitude: number | null = null;
    latitude: number | null = null;
    type: PopupType | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    openDealPopup(id: number) {
        this.id = id;
        this.type = PopupType.Deal;
    }

    openLeadPopup(id: number) {
        this.id = id;
        this.type = PopupType.Lead;
    }

    openLeaseCompPopup(id: number) {
        this.id = id;
        this.type = PopupType.LeaseComp;
    }

    openSaleCompPopup(id: number) {
        this.id = id;
        this.type = PopupType.SaleComp;
    }

    openTenantInMarketPopup(id: number) {
        this.id = id;
        this.type = PopupType.TenantInMarket;
    }

    openPropertyPopup(longitude: number, latitude: number) {
        this.longitude = longitude;
        this.latitude = latitude;
        this.type = PopupType.Property;
    }

    openLocationPopup(id: number) {
        this.id = id;
        this.type = PopupType.Location;
    }

    close() {
        this.id = null;
        this.longitude = null;
        this.latitude = null;
        this.type = null;
    }

    clear() {
        this.close();
    }
}
